module.exports = __webpack_public_path__ + "cc0fffcd63385b72f7eeccf7dfcd30bf.png";